import { useState } from 'react';
import api, { formatApiError } from '@/lib/api';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import {
  Lock,
  Eye,
  EyeOff,
  ShieldCheck
} from 'lucide-react';


export default function ParceiroAlterarSenhaPage() {

  const [form, setForm] = useState({
    current_password: '',
    new_password: '',
    confirm_password: ''
  });

  const [showCurrent, setShowCurrent] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [saving, setSaving] = useState(false);


  async function handleSubmit(e) {

    e.preventDefault();

    if (
      !form.current_password ||
      !form.new_password ||
      !form.confirm_password
    ) {
      toast.error('Preencha todos os campos');
      return;
    }

    if (form.new_password.length < 6) {
      toast.error(
        'A nova senha deve ter no mínimo 6 caracteres'
      );
      return;
    }

    if (
      form.new_password !==
      form.confirm_password
    ) {
      toast.error(
        'Nova senha e confirmação não conferem'
      );
      return;
    }

    setSaving(true);

    try {

      await api.post(
        '/auth/change-password',
        form
      );

      toast.success(
        'Senha alterada com sucesso!'
      );

      setForm({
        current_password: '',
        new_password: '',
        confirm_password: ''
      });

    } catch (err) {

      toast.error(formatApiError(err));

    } finally {

      setSaving(false);

    }
  }


  return (

    <div className="max-w-xl mx-auto space-y-7">

      <div>

        <p className="text-xs font-bold tracking-[0.18em] uppercase text-slate-400">
          Segurança
        </p>

        <h1 className="text-2xl sm:text-3xl font-bold text-slate-950 mt-1">
          Alterar senha
        </h1>

        <p className="text-sm text-slate-500 mt-2">
          Atualize sua senha de acesso ao Portal do Parceiro.
        </p>

      </div>


      <form
        onSubmit={handleSubmit}
        className="bg-white border border-slate-200 rounded-2xl p-5 sm:p-7 space-y-5"
      >

        {/* ATUAL */}

        <div className="space-y-2">

          <Label className="text-sm font-semibold text-slate-700">
            Senha atual
          </Label>

          <div className="relative">

            <Input
              type={showCurrent ? 'text' : 'password'}
              value={form.current_password}
              onChange={(e) =>
                setForm({
                  ...form,
                  current_password: e.target.value
                })
              }
              placeholder="Digite sua senha atual"
              className="h-11 bg-white border-slate-200 text-slate-900 pr-11"
              required
            />

            <button
              type="button"
              onClick={() =>
                setShowCurrent(!showCurrent)
              }
              className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-700"
            >
              {showCurrent ? (
                <EyeOff className="w-4 h-4" />
              ) : (
                <Eye className="w-4 h-4" />
              )}
            </button>

          </div>

        </div>


        {/* NOVA */}

        <div className="space-y-2">

          <Label className="text-sm font-semibold text-slate-700">
            Nova senha
          </Label>

          <div className="relative">

            <Input
              type={showNew ? 'text' : 'password'}
              value={form.new_password}
              onChange={(e) =>
                setForm({
                  ...form,
                  new_password: e.target.value
                })
              }
              placeholder="Mínimo 6 caracteres"
              className="h-11 bg-white border-slate-200 text-slate-900 pr-11"
              required
            />

            <button
              type="button"
              onClick={() =>
                setShowNew(!showNew)
              }
              className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-700"
            >
              {showNew ? (
                <EyeOff className="w-4 h-4" />
              ) : (
                <Eye className="w-4 h-4" />
              )}
            </button>

          </div>


          {form.new_password &&
            form.new_password.length < 6 && (

              <p className="text-xs text-red-600">
                Mínimo 6 caracteres
              </p>

            )}

        </div>


        {/* CONFIRMACAO */}

        <div className="space-y-2">

          <Label className="text-sm font-semibold text-slate-700">
            Confirmar nova senha
          </Label>

          <div className="relative">

            <Input
              type={showConfirm ? 'text' : 'password'}
              value={form.confirm_password}
              onChange={(e) =>
                setForm({
                  ...form,
                  confirm_password: e.target.value
                })
              }
              placeholder="Repita a nova senha"
              className="h-11 bg-white border-slate-200 text-slate-900 pr-11"
              required
            />

            <button
              type="button"
              onClick={() =>
                setShowConfirm(!showConfirm)
              }
              className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-700"
            >
              {showConfirm ? (
                <EyeOff className="w-4 h-4" />
              ) : (
                <Eye className="w-4 h-4" />
              )}
            </button>

          </div>


          {form.confirm_password &&
            form.new_password !==
              form.confirm_password && (

              <p className="text-xs text-red-600">
                As senhas não conferem
              </p>

            )}

        </div>


        <Button
          type="submit"
          disabled={saving}
          className="w-full h-11 bg-slate-900 text-white hover:bg-slate-800 font-semibold"
        >
          <ShieldCheck className="w-4 h-4 mr-2" />

          {saving
            ? 'Alterando...'
            : 'Alterar senha'}

        </Button>


        <div className="bg-slate-50 border border-slate-200 rounded-xl p-4">

          <div className="flex gap-3">

            <Lock className="w-4 h-4 text-slate-400 shrink-0 mt-0.5" />

            <p className="text-xs text-slate-500 leading-relaxed">
              Use pelo menos 6 caracteres. Para maior segurança,
              combine letras, números e símbolos.
            </p>

          </div>

        </div>

      </form>

    </div>
  );
}
